import { render, staticRenderFns } from "./UiChart.vue?vue&type=template&id=5bb3d6c6&scoped=true&"
import script from "./UiChart.vue?vue&type=script&lang=js&"
export * from "./UiChart.vue?vue&type=script&lang=js&"
import style0 from "./UiChart.vue?vue&type=style&index=0&id=5bb3d6c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb3d6c6",
  null
  
)

export default component.exports